<template>
<div class="ui segments">

  <div class="ui segment">
  <div class="ui breadcrumb">
  <router-link :to="{name:'home'}" class="section">Sākums</router-link>
  <span class="divider">/</span>
  <div class="active section">Gaida piegādi</div>
</div>
</div>

  <div class="ui segment">

      <skipped-goods-warning v-bind:storeStatus="cartStoreStatus"></skipped-goods-warning>
    <table class="ui selectable table orange">
      <div class="ui loader" v-bind:class="{ active: storeStatus.loading }"></div>
      <thead v-if="!checkClientWidth">
        <tr>
          <th>Piegādes datums</th>
          <th>Adrese</th>
          <th>Kopsumma</th>
          <th>Statuss</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" v-bind:class="{ warning: item.status == 0 }">
          <td>{{item.delivery_date}}</td>
          <td>{{item.address}}</td>
          <td>{{item.total_amount_with_bail_and_vat}} &euro;</td>
          <td v-if="item.status == 3"><i class="clock icon"></i> Tiek apstrādāts</td>
          <td v-else-if="item.status == 4"><i class="hourglass start icon"></i> Gaida piegādi</td>
          <td v-else><i class="warning attention icon"></i> Atcelts</td>
          <td><button v-if="item.lock == 0 && item.status == 3" v-on:click="goToEditPage(item)" class="ui custom_brown button">Rediģēt</button>
            <button v-if="(item.lock == 1 && item.status == 3) || item.status == 4" v-on:click="goToEditPage(item)" class="ui custom_brown button">Apskatīt</button>
            <button v-if="item.status == 3 && item.autoship_id <=0" v-on:click="cancelOrder(item)" class="ui custom_brown icon button"><i class="right trash icon"></i></button>
            <router-link v-if="item.autoship_id > 0" :to="{name:'autoship'}" class="ui custom_brown icon button"><i class="right share icon"></i></router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- delete prompt -->
  <div id="waiting-delivery-delete-dialog" class="ui basic modal">
    <div class="ui icon header">
      <i class="trash icon"></i>
      Vai dzēst ierakstu?
    </div>
    <div class="content">
      <p>Dzēšot Pasūtījumu, iepriekš samaksātā summa tiks atgriezta uz jūsu kontu!</p>
    </div>
    <div class="actions">
      <div class="ui grey basic cancel inverted button">
        <i class="remove icon"></i>
        Nē
      </div>
      <div class="ui custom_brown ok inverted button" @click="deleteOrder">
        <i class="checkmark icon"></i>
        Jā
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SkippedGoodsWarning from './SkippedGoodsWarning';

export default {

  components:{
      'skipped-goods-warning': SkippedGoodsWarning
  },

  data() {
    return {
      itemForDelete:false
    }
  },

  computed: {
    storeStatus() {
      return this.$store.state.orderStore.status
    },
    cartStoreStatus() {
      return this.$store.state.cartStore.status
    },
    items() {
      return this.$store.state.orderStore.items;
    },
    checkClientWidth(){
     return document.documentElement.clientWidth < 768
   },

  },

  activated: function() {
    this.itemForDelete = false;
    this.$store.dispatch('loadOrderWaitingForDelivery');
  },



  methods: {

    goToEditPage(item) {

      // process is as follows:
      // order is copied to cart and user will modify cart not order.
      // Once user save data he will update order (if its still possible) and cart will be deleted
      // to prevent clashes with active cart, we will use autoshipCart store for frontend. For future could merge cart/autoship/and this into one
      this.$store.commit('SET_ORDER_ITEMS', [])
      this.$store.commit('SET_ORDER_DETAILS', {})
      this.$store.dispatch('convertOrderToCart',item).then((response) => {

        this.$router.push({
            name: 'waiting-for-delivery-edit',
            params: {
                id: response.data.data.id
            }
        });

      }).catch((error) => {

        console.error('Order conversion failed')
      });

    },

    cancelOrder(item){

      this.itemForDelete = item
      $('#waiting-delivery-delete-dialog')
        .modal('show')
      ;
    },

    deleteOrder() {

        this.$store.dispatch('deleteOrder',this.itemForDelete).then((response) => {
            this.$store.dispatch('loadUser'); //reload user to refresh balance
        }).catch((error) => {

            //reload orders as reason for error could be that order is deleted by admin or status is changed to waiting delivery
            this.$store.dispatch('loadOrderWaitingForDelivery');
        });

    }
  },



}
</script>



// WEBPACK FOOTER //
// WaitingForDeliveryPage.vue?5a2cb1ad